<template>
  <div class="page">
    <Error v-if="isError" />
    <div v-else>
      <PageGenerator
      v-if="pageConfigReady && !isError"
      :pageConfig="pageConfig"
      :env="env"
      :id="id"
      :userFrom="userFrom"
      :isRepeatSubmit="isRepeatSubmit"
    />
    </div>
  </div>
</template>

<script>
import { PageGenerator } from "@taomee/dct-generator";
import "@taomee/dct-generator/dist/dct-generator.css";
import ApiClient from "@taomee/dct-generator/src/utils/api.js";
import axios from "axios";
import Error from "@/views/Error.vue";

export default {
  name: "Page",
  components: {
    PageGenerator,
    Error,
  },
  data() {
    return {
      instance: null,
      pageConfig: {},
      env: "local",
      pageConfigReady: false,
      isError: false,
      envHost: {
        dev: "http://test.dc.61.com/resource/",
        pre: "https://admin-webevent-test.taomee.com/resource/",
        prod: "https://webres.61.com/dynamic/",
      },
      userFrom: "",
      id: "",
      isRepeatSubmit: 0,
    };
  },
  mounted() {
    // 使用 VUE_APP_ENV 来区分不同的构建环境
    // NODE_ENV 在 build 时总是 production，无法区分 pre/prod
    const appEnv = process.env.VUE_APP_ENV;
    if (appEnv === "dev") {
      this.env = "dev";
    } else if (appEnv === "pre") {
      this.env = "pre";
    } else if (appEnv === "prod") {
      this.env = "prod";
    }
    const id = this.$route.query.id;
    this.id = id;
    this.userFrom = this.$route.query.channel;
    this.instance = new ApiClient(this.env);
    this.getPageConfig(id);
  },
  methods: {
    async getPageConfig(id) {
      this.pageConfigReady = false;
      this.isError = false;
      try {
        let url = await this.instance.get(`getPageConfigByID&id=${id}`);
        if (!url) {
          this.handleError();
          return;
        }
        const resourceUrl = this.envHost[this.env] + id + "/";
        url = resourceUrl + url;
        await this.fetchAndProcessConfig(url);
      } catch (e) {
        this.handleError();
      }
    },
    async fetchAndProcessConfig(url) {
      try {
        const res = await axios.get(url);
        if (!res.data) {
          this.handleError();
          return;
        }
        this.isRepeatSubmit = res.data.isRepeatSubmit;
        await this.getFinalConfig(res.data);
      } catch (e) {
        this.handleError();
      }
    },
    async getFinalConfig(config) {
      const url = `${this.envHost[this.env] + config.id + '/' + config.shareLink}`;
      try {
        const res = await axios.get(url);
        if (!res.data) {
          this.handleError();
          return;
        }
        this.pageConfig = res.data;
        this.pageConfigReady = true;
      } catch (e) {
        this.handleError();
      }
    },
    handleError() {
      this.isError = true;
    },
  },
};
</script>

<style scoped>
.page {
  width: 100%;
  height: 100%;
}
</style>
